export const MDM_SOFTWARE = {
  TITLE: 'Software',
  SEARCH_PLACEHOLDER: 'Search software...',
  TOTAL_SOFTWARE: 'software',
  NO_SOFTWARE: 'No software available',
  NO_RESULTS: 'No software found',
  ADD_CUSTOM_PACKAGE: 'Add custom package',
  ADD_FROM_CATALOG: 'Add from catalog',
  ORGANIZATION_SUBTITLE: 'Your approved software list. Install it on hosts from here',
  CATALOG_SUBTITLE: 'Software vetted by Qalea. Add what your team uses to the approved list',
  APPROVED_TOOLTIP: 'This software is approved by your organization',
}

export const MDM_SOFTWARE_TABS = {
  TEAM_SOFTWARE: 'Organization software',
  FLEET_CATALOG: 'Qalea catalog',
}

export const MDM_SOFTWARE_FILTERS = {
  STATUS: 'Status',
  PLATFORM: 'Platform',
  CLEAR_FILTERS: 'Clear',
}

export const MDM_SOFTWARE_PLATFORM = {
  MACOS: 'macOS',
  WINDOWS: 'Windows',
  LINUX: 'Linux',
  IOS: 'iOS',
  ANDROID: 'Android',
  ALL: 'All Platforms',
}

export const MDM_SOFTWARE_STATUS = {
  INSTALLED: 'Installed',
  NOT_INSTALLED: 'Not installed',
  IN_APPROVED_LIST: 'In approved list',
  NOT_IN_APPROVED_LIST: 'Not in approved list',
  PENDING: 'Pending',
  FAILED: 'Failed',
}

export const MDM_SOFTWARE_DRAWER = {
  TITLE: 'Software Details',
  STATUS: 'Status',
  NOT_INSTALLED_STATUS: 'Not installed',
  PLATFORM: 'Platform',
  SOURCE: 'Source',
  SOURCE_SOFTWARE_CATALOG: 'Qalea catalog',
  SOURCE_ORGANIZATION_CATALOG: 'Organization Catalog',
  PACKAGE_TYPE: 'Package Type',
  INSTALLED_GROUPS: 'Installed on',
  AVAILABLE_GROUPS: 'Available in',
  AVAILABLE_GROUPS_INFO: "Offered in the work Play Store of these groups' phones. Each person installs it from there.",
  INSTALLED_GROUPS_INFO: 'Groups with hosts that have this software installed, or where its install failed.',
  GROUPS: (count: number) => `Groups (${count})`,
  NOT_INSTALLED: 'Not installed on any groups',
  HOSTS_INSTALLED: (count: number) => `${count} installed`,
  HOSTS_PENDING: (count: number) => `${count} pending`,
  HOSTS_FAILED: (count: number) => `${count} failed`,
  INSTALL: 'Install',
  UPDATE: 'Update',
  UNINSTALL: 'Uninstall',
  OTHER_HOSTS: (count: number) => `Other hosts (${count})`,
  OTHER_HOSTS_DESCRIPTION: 'Hosts that have this software installed but are not part of any managed group.',
  INSTALL_DETAILS: 'Install details',
  INSTALL_SCRIPT_OUTPUT: 'Install script output',
  PRE_INSTALL_QUERY_OUTPUT: 'Pre-install query output',
  POST_INSTALL_SCRIPT_OUTPUT: 'Post-install script output',
  NO_OUTPUT: 'No output',
  RETRY_INSTALLATION: 'Retry installation',
  HOST_STATUS: {
    INSTALLED: 'Installed',
    PENDING: 'Pending',
    FAILED: 'Failed',
    AVAILABLE: 'Available',
    NOT_INSTALLED: 'Not installed',
  },
}

export const MDM_SOFTWARE_CARD = {
  UPDATE: 'Update',
  UNINSTALL: 'Uninstall',
  INSTALLING: 'Installing',
  UNINSTALLING: 'Uninstalling',
  INSTALLING_ON_HOSTS: (count: number) => `Installing on ${count} ${count === 1 ? 'host' : 'hosts'}`,
  UNINSTALLING_FROM_HOSTS: (count: number) => `Uninstalling from ${count} ${count === 1 ? 'host' : 'hosts'}`,
  INSTALLING_ON_SHORT: (count: number) => `Installing on ${count}…`,
  UNINSTALLING_FROM_SHORT: (count: number) => `Uninstalling from ${count}…`,
  RETRY: 'Retry',
  INSTALL: 'Install',
  STATUS_GETTING: 'Getting status…',
  STATUS_NOT_INSTALLED: 'Not installed',
  STATUS_PENDING_ON_HOSTS: (count: number) => `Pending on ${count} ${count === 1 ? 'host' : 'hosts'}`,
  STATUS_INSTALLED_ON_HOSTS: (count: number) => `Installed on ${count} ${count === 1 ? 'host' : 'hosts'}`,
  STATUS_FAILED_ON_HOSTS: (count: number) => `Failed on ${count} ${count === 1 ? 'host' : 'hosts'}`,
  STATUS_FAILED_INFO: 'The last install on these hosts failed. Open a failed host to see why and retry.',
  STATUS_INSTALLED_OF: (installed: number, total: number) => `${installed} of ${total} installed`,
  ADD_TO_APPROVED_LIST: 'Add to approved list',
  IN_APPROVED_LIST: 'In approved list',
}

export const MDM_SOFTWARE_DIALOG = {
  VERSION: 'Version',
  INSTALL_COMPLETE: 'Installation has been queued.',
  INSTALL_DESCRIPTION: 'Select the groups where you want to install this software.',
  UNINSTALL_COMPLETE: 'Uninstallation has been queued.',
  UNINSTALL_DESCRIPTION: 'Select the groups where you want to uninstall this software.',
  SEARCH_GROUPS: 'Search groups...',
  DONE: 'Done',
  CANCEL: 'Cancel',
  INSTALLING: 'Queueing...',
  INSTALL: 'Install',
  UNINSTALLING: 'Queueing...',
  UNINSTALL: 'Uninstall',
  HOSTS: 'hosts',
  ALL_HOSTS_IN_GROUP: 'All hosts in this group',
  SUCCESS: 'Success',
  QUEUED: 'Queued',
  ERROR: 'Error',
  NOT_APPROVED_TITLE: 'Software Not Approved',
  NOT_APPROVED_MESSAGE: "This software is not in your organization's Approved Software list.",
  APPROVE_FOR_ORG: 'Approve for Organization',
  APPROVE_CHECKBOX: 'Add to Approved Software list before installing',
  APPROVING: 'Approving...',
  LOADING_INSTALLED_GROUPS: 'Loading installed groups...',
  INSTALLED_GROUPS_ERROR: 'Failed to load installed groups. Please try again.',
}

export const MDM_SOFTWARE_FORM = {
  TITLE: 'Add Software',
  MODE_PACKAGE: 'Package',
  MODE_PLAY_STORE: 'Play Store app',
  APPLICATION_ID: 'Application ID',
  APPLICATION_ID_PLACEHOLDER: 'com.android.chrome',
  APPLICATION_ID_HELP: 'The ID at the end of the app’s Google Play Store URL.',
  TARGET_GROUPS: 'Groups',
  NO_ANDROID_GROUPS: 'No Android groups yet. Create one before adding a Play Store app.',
  ANDROID_PUBLISH_HELP:
    'The app is published to the Play Store in the work profile of every phone in these groups, where the employee installs it.',
  NAME: 'Name',
  VERSION: 'Version',
  PLATFORM: 'Platform',
  PACKAGE_TYPE: 'Package Type',
  SELECT_PACKAGE_TYPE: 'Select package type',
  PACKAGE_FILE: 'Package File',
  UPLOAD_PACKAGE: 'Upload Package',
  WEBSITE: 'Website (optional)',
  INSTALL_SCRIPT: 'Install script (optional)',
  UNINSTALL_SCRIPT: 'Uninstall script (optional)',
  CREATE_SOFTWARE: 'Add Software',
  CANCEL: 'Cancel',
}

export const MDM_SOFTWARE_MESSAGES = {
  CREATED: 'Software created successfully',
  FAILED_TO_CREATE: 'Failed to create software',
  ADDED_TO_APPROVED_LIST: (name: string) => `${name} added to the approved list`,
  FAILED_TO_ADD_TO_APPROVED_LIST: 'Failed to add to the approved list',
}
